import { ResourceStore } from 'src/stores/ResourceStore/ResourceStore';

export const PartnerTypeResourceStore = new ResourceStore(
    'data/partnerType.json',
);
